import ICON_ARROW from '../../../../public/static/v4/myPage/icon-arrow.svg';
import SingleText from '../../../common/component/SingleText';

interface IProps {
  text: string;
}

export default function TextWithArrowV4({text}: IProps) {
  return (
    <>
      <SingleText className="s12-medium-white ml-8" width="auto">
        {text}
      </SingleText>
      <img
        width="5"
        height="10"
        src={ICON_ARROW}
        className="ml-5 mr-8"
        alt=""
      />
    </>
  );
}
